/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ExpertDocumentDto } from './ExpertDocumentDto';
export type UpdateOnboardingProfileDto = {
    /**
     * Full name
     */
    full_name?: string;
    /**
     * Email address (no verification needed)
     */
    email?: string;
    /**
     * Gender
     */
    gender?: UpdateOnboardingProfileDto.gender;
    /**
     * Date of birth (ISO date)
     */
    date_of_birth?: string;
    /**
     * Profile image URL from media upload
     */
    profile_image_url?: string;
    /**
     * Phone number (digits only)
     */
    phone_number?: string;
    /**
     * Phone country code
     */
    phone_country_code?: string;
    /**
     * Latitude
     */
    latitude?: number;
    /**
     * Longitude
     */
    longitude?: number;
    /**
     * Address line 1
     */
    address_line1?: string;
    /**
     * Address line 2
     */
    address_line2?: string;
    /**
     * City for location
     */
    location_city?: string;
    /**
     * State for location
     */
    location_state?: string;
    /**
     * Country
     */
    country?: string;
    /**
     * Postal/zip code
     */
    postal_code?: string;
    /**
     * IANA timezone identifier
     */
    timezone?: string;
    /**
     * When true, session location copies current location data
     */
    session_same_as_current?: boolean;
    /**
     * Session latitude
     */
    session_latitude?: number;
    /**
     * Session longitude
     */
    session_longitude?: number;
    /**
     * Session address line 1
     */
    session_address_line1?: string;
    /**
     * Session address line 2
     */
    session_address_line2?: string;
    /**
     * Session location city
     */
    session_location_city?: string;
    /**
     * Session location state
     */
    session_location_state?: string;
    /**
     * Session country
     */
    session_country?: string;
    /**
     * Session postal code
     */
    session_postal_code?: string;
    /**
     * Session IANA timezone identifier
     */
    session_timezone?: string;
    /**
     * Service radius in kilometers (expert only)
     */
    service_radius_km?: number;
    /**
     * Service type IDs that client is interested in (e.g., Personal Trainer, Physiotherapist)
     */
    preferences?: Array<string>;
    /**
     * Short bio
     */
    short_bio?: string;
    /**
     * Available training modes
     */
    modes?: Array<'online' | 'client_location' | 'expert_location'>;
    /**
     * Years of professional experience
     */
    years_of_experience?: number;
    /**
     * Education level
     */
    education_level?: string;
    /**
     * Service type UUID (one per expert)
     */
    service_type_id?: string;
    /**
     * Sub-service UUIDs (multiple allowed under the chosen service type)
     */
    sub_service_ids?: Array<string>;
    /**
     * Expert documents (appends to existing, file must already be uploaded via /media)
     */
    documents?: Array<ExpertDocumentDto>;
};
export namespace UpdateOnboardingProfileDto {
    /**
     * Gender
     */
    export enum gender {
        MALE = 'male',
        FEMALE = 'female',
        OTHER = 'other',
    }
}

